declare const API_URL: string | undefined;

const localApiUrl = 'http://localhost:3000';
const configuredApiUrl = typeof API_URL === 'string' ? API_URL : localApiUrl;

export const environment = {
  apiUrl: configuredApiUrl.replace(/\/$/, ''),
} as const;
